<template>
  <div>
    <div>
      <h1 class="mb-8 font-bold text-3xl">
        Pembayaran Akhir Studi Mahasiswa
      </h1>
    </div>
    <div class="w-full">
      <div class="flex flex-nowrap">
        <div class="flex-none pl-1 mr-4 md:w-1/5">
          <label
            for="verification_date_sdate"
            class="text-sm form-label">Tanggal Pembayaran:</label>
          <flat-pickr
            id="verification_date_sdate"
            v-model="form.payment_date"
            class="form-input text-center"
            placeholder="YYYY-MM-DD" />
        </div>
        <select-input
          v-model="form.payment_status"
          class="pb-4 md:pr-4"
          label="Status Pembayaran">
          <option
            :value="null"
            default
            class="text-center">
            ALL
          </option>
          <option :value="999" class="text-center">
            N/A
          </option>
          <option
            v-for="option in paymentStatusOptions"
            :key="option.id"
            :value="option.id">
            {{ option.status }}
          </option>
        </select-input>
        <select-input
          v-model="form.graduation_year"
          class="pb-4 md:pr-4"
          label="Tahun Pembayaran">
          <option
            value="ALL"
            default
            class="text-center">
            ALL
          </option>
          <option
            v-for="option in graduationYearOptions"
            :key="option"
            :value="option">
            {{ option }}
          </option>
        </select-input>
        <div class="flex-none">
          <label class="text-sm form-label">Cari Nama / NIM:</label>
          <search-filter
            v-model="form.search"
            placeholder="Cari Nama atau NIM..."
            :show-dropdown="false"
            class="max-w-md"
            @reset="reset" />
        </div>
        <button
          class="md:my-7 md:ml-auto btn-green"
          @click.prevent="exportXls">
          <i class="fas fa-file-excel" /> Export Excel
        </button>
      </div>
    </div>
    <div class="overflow-x-scroll bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4 text-left">
              Nama Mahasiswa / NIM
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Kampus
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Kota Studi
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Tahun Masuk Kuliah
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Semester
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Jenjang Pendidikan
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Tanggal Pembayaran
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Nominal
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Status Pembayaran
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in eosPayments.data"
            :key="row.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100">
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos_payment.edit', row.id)">
                {{ row.mahasiswa.name }}<br><small>{{
                  row.mahasiswa.nim
                }}</small>
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos_payment.edit', row.id)">
                {{ row.universitas.name }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos_payment.edit', row.id)">
                {{ row.universitas.kota_studi }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos_payment.edit', row.id)">
                {{ row.mahasiswa.college_entry_year }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos_payment.edit', row.id)">
                {{ row.mahasiswa.current_semester }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos_payment.edit', row.id)">
                {{ row.mahasiswa.jenjang_pendidikan }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos_payment.edit', row.id)">
                {{ row.payment_date }}
              </Link>
            </td>
            <td class="py-4 px-6 text-right border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos_payment.edit', row.id)">
                {{ formatNumber(row.payment_amount) }}
              </Link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <Link
                class="focus:text-indigo-500"
                :href="route('eos_payment.edit', row.id)">
                {{ row.payment_status }}
              </Link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="eosPayments.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import SelectInput from '@/Shared/SelectInput'
import Pagination from '@/Shared/Pagination'
import { Link, router } from '@inertiajs/vue2'

export default {
  metaInfo: { title: 'Pembayaran Akhir Studi ' },

  layout: Layout,

  components: {
    Pagination,
    flatPickr,
    SearchFilter,
    SelectInput,
    Link,
  },

  props: {
    filters: Object,
    eosPayments: Object,
    paymentStatusOptions: Array,
    graduationYearOptions: Array,
    currGraduationYear: Number,
  },

  data () {
    return {
      form: {
        search: this.filters.search,
        payment_date: this.filters.payment_date,
        payment_status: this.filters.payment_status,
        graduation_year: this.filters.graduation_year,
      },
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        router.get(this.route('eos_payment.index'), pickBy(this.form), {
          preserveState: true,
        })
      }, 150),
    },
  },

  methods: {
    reset () {
      this.form = mapValues(this.form, () => null)
      this.form.graduation_year = this.currGraduationYear
    },
    formatNumber (num) {
      return num ? num.toLocaleString('id-ID') : '0'
    },
    exportXls () {
      window.open(
        this.route('eos_payment.index', {
          ...pickBy(this.form),
          export: 1,
        }),
        '_blank',
      )
    },
  },
}
</script>
